module.exports = __webpack_public_path__ + "img/logout.84c6dc6b.svg";